import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

const ViewerJoining = (props) => {
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const viewer_title = _.get(joining_data, "viewer_title", "Viewer");
  const viewer_top = _.get(joining_data, "viewer_top", "The presenter is setting up the slides!");
  const viewer_bottom = _.get(
    joining_data,
    "viewer_bottom",
    "Once the presentation starts, you can look at your phone for the SlideKick slides for additional information on what is being presented.",
  );
  const host = _.get(props, "gameReducer.roomObj.host");
  return (
    <div className="ViewAfterSubmitWrap">
      <h1 className="roleText">{viewer_title}</h1>
      <div className="ViewAfterSubmit">
        <div className="instructionView">
          <p className="instructionText">{viewer_top}</p>
          <img
            src={
              host?.profile_image === "profileImage"
                ? `https://cdn.comedywire.com/images/default-profile-icon.png`
                : host?.profile_image
            }
            alt=""
            className="userImage"
          />
          <p className="username">{host?.display_name}</p>
          <p className="instructionPara">{viewer_bottom}</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewerJoining);
